import { useCallback, useEffect, useState } from 'react';
import {
  getFullscreenElement,
  isBrowserFullscreenActive,
  isBrowserFullscreenSupported,
  requestBrowserFullscreen,
  exitBrowserFullscreen,
  toggleBrowserFullscreen,
} from '../fullscreen/browserFullscreen';

/**
 * Tracks browser Fullscreen API state and exposes enter/exit/toggle helpers.
 */
export function useBrowserFullscreen() {
  const [supported] = useState(() => isBrowserFullscreenSupported());
  const [isActive, setIsActive] = useState(() => isBrowserFullscreenActive());

  useEffect(() => {
    if (!supported) {
      return undefined;
    }

    const sync = () => {
      setIsActive(getFullscreenElement() != null);
    };

    document.addEventListener('fullscreenchange', sync);
    document.addEventListener('webkitfullscreenchange', sync);

    return () => {
      document.removeEventListener('fullscreenchange', sync);
      document.removeEventListener('webkitfullscreenchange', sync);
    };
  }, [supported]);

  const enter = useCallback(async () => {
    await requestBrowserFullscreen();
  }, []);

  const exit = useCallback(async () => {
    await exitBrowserFullscreen();
  }, []);

  const toggle = useCallback(async () => {
    await toggleBrowserFullscreen();
  }, []);

  return {
    supported,
    isActive,
    enter,
    exit,
    toggle,
  };
}
